export const ERROR = 'error';
export const LOADING = 'loading';
export const SYSTEM = 'system';
export const USER = 'user';